import { resolveSemanticColor } from '@/theme/semanticTokens';
import { s } from '@/theme/tokens';
import type { SxProps, Theme } from '@/ui/primitives/types';

type ThemeSxObject = Exclude<SxProps<Theme>, readonly unknown[] | ((theme: Theme) => unknown)>;
type ThemeSxFn = (theme: Theme) => ThemeSxObject;

export const projectCsvMappingFieldRowLabelWidth = '80px';
export const projectCsvMappingFieldRowValidationWidth = '24px';

export const projectCsvMappingFieldRowSx: ThemeSxObject = {
  display: 'grid',
  gridTemplateColumns: {
    xs: `minmax(0, 1fr) ${projectCsvMappingFieldRowValidationWidth}`,
    sm: `${projectCsvMappingFieldRowLabelWidth} minmax(0, 1fr) ${projectCsvMappingFieldRowValidationWidth}`,
  },
  alignItems: 'center',
  columnGap: s('lg'),
  rowGap: s('md'),
  width: '100%',
  minWidth: 0,
  borderBottom: '1px solid',
  borderColor: 'divider',
  px: s('xl'),
  py: s('md'),
  '&:last-of-type': {
    borderBottom: 0,
  },
};

export const projectCsvMappingFieldRowLabelSx: ThemeSxFn = (theme) => ({
  fontSize: theme.typography.subtitle1.fontSize,
  lineHeight: theme.typography.subtitle1.lineHeight,
  color: resolveSemanticColor(theme, 'textSecondary'),
  whiteSpace: 'nowrap',
  gridColumn: { xs: '1 / -1', sm: 'auto' },
});

export const projectCsvMappingFieldRowInputSx: ThemeSxObject = {
  minWidth: 0,
  '& .MuiInputBase-root': {
    width: '100%',
    backgroundColor: 'var(--surface-card)',
    transition: 'border-color 140ms ease, box-shadow 140ms ease, background-color 140ms ease',
  },
  '& .MuiInputBase-root.Mui-focused': (theme) => ({
    boxShadow: `0 0 0 3px color-mix(in srgb, ${resolveSemanticColor(
      theme,
      'accent',
    )} 16%, transparent)`,
  }),
  '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': (theme) => ({
    borderColor: resolveSemanticColor(theme, 'accent'),
  }),
};

export const projectCsvMappingFieldRowAdornmentSx: ThemeSxObject = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: projectCsvMappingFieldRowValidationWidth,
};
